module.exports = __webpack_public_path__ + "static/img/xigua.464b754e.png";